import React, { useState } from "react";
import { Accordion, Grid, Icon, Label, List, ListDescription, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css";

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/legal/";

export const ExploringBenefitsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0,1,2,3,4]);
  const [activeRightAccordionIndexes] = useState([0,1,2,3,4]);

  const renderAccordionUnderstanding = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <p className={styles.learnMoreAccordionText} >
          Living on a fixed income makes it difficult to juggle unexpected expenses. Older adults are now filing for
          bankruptcy more frequently and piling up credit card charges, home equity debt, and life insurance loans. 
          Nearly half of older adults who end up in bankruptcy say that they filed
          because of a medical reason.
          <br/><br/>
          Investigating these options can help maximize the older adult's financial situation and help to provide 
          financial security for the rest of their years.</p>
      </Segment>
      </>
    );
  };
  const renderAccordionBenefits = () => {
    return (
      <>
      <Segment raised className={styles.segmentWhiteBG} > 
        <List divided relaxed bulleted className={styles.learnMoreBulletedList}  >
          <>
            <List.Item header="Medicaid, Medicare, & Prescription Drug Plans" />
            <List.Item header="Supplemental Security Income" />
            <List.Item header="Pensions & Social Security Retirement Insurance" />
            <List.Item header="Home Loan Guaranty Benefits" />
            <List.Item header="Homestead Tax Exemptions" />
            <List.Item header="Life Insurance" />
            <List.Item style={{bottomBorder: "none"}}>
              <List.Header>Veteran Benefits</List.Header>
              <ListDescription> (e.g. Burial Benefits, Survivor Benefits, Healthcare Benefits, etc.)</ListDescription>
            </List.Item>
          </>
        </List>
      </Segment>
      </>
    );
  };

  const accordions = [
    { key: 'understanding',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Identifying and Locating Benefits </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionUnderstanding()}/>)
      }
    }
  ];
  const accordionsRight = [
    { key: 'benefits',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > Types of Benefits to Look For </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionBenefits()}/>)
      }
    }
  ];

  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}ExploringBenefitsInfoOne.png)`, }}>
      <div className={styles.learnMoreModalContent}>
        <Grid stackable doubling padded columns='equal'>
          <Grid.Column >
            <Accordion  panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
          </Grid.Column>

          <Grid.Column>
            <Accordion panels={accordionsRight} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeRightAccordionIndexes} exclusive={false} />
          </Grid.Column>
        </Grid>
      </div>
      </Segment>    
    </>
    );      
};

